import { reduce } from 'lodash'
import styled from 'styled-components'

import { AI_HIGHLIGHT_STYLES } from '../../constants'

const StyledAiHighlightedText = styled.span(props =>
  reduce(
    props.highlights,
    (result, highlight) => ({
      ...result,
      ...(AI_HIGHLIGHT_STYLES?.[highlight]?.style || {}),
    }),
    {},
  ),
)

export default StyledAiHighlightedText
